// Global user state — insurance, account, employer, profile
let state = {
  carrier: null,
  planType: null,
  memberId: null,
  groupNum: null,
  planName: null,
  accountType: 'consumer',      // consumer | employer_sponsored
  acquisitionSource: 'organic', // organic | employer_link | provider_referral
  employerId: null,
  user: null,
  firstName: null,
  lastName: null,
  zipCode: null,
  dob: null,                    // YYYY-MM-DD
  age: null,                    // derived from dob when available
  gender: null,                 // biological sex
  recentSymptomLevel: null,       // 'urgent' | 'soon' | 'home' — set if session within 48h
  recentSymptomAt: null,
  recentTriageSessionId: null,    // UUID of triage_sessions row that triggered the nudge
  medications: [],              // [{ id, medication_name, dosage, frequency, cost_plus_price }]
  userLat: null,                // from geolocation API
  userLng: null,
};

const listeners = new Set();

export function getState() {
  return { ...state };
}

export function setState(updates) {
  state = { ...state, ...updates };
  listeners.forEach(fn => fn(state));
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function useInsuranceLabel() {
  const carrierNames = {
    bcbs: 'BlueCross BlueShield',
    aetna: 'Aetna',
    cigna: 'Cigna',
    united: 'UnitedHealthcare',
    humana: 'Humana',
    medicaid: 'SC Medicaid',
    medicare: 'Medicare',
  };
  const planNames = { ppo: 'PPO', hmo: 'HMO', hdhp: 'HDHP', epo: 'EPO' };
  const { carrier, planType } = state;
  if (!carrier) return null;
  return `${carrierNames[carrier] || carrier}${planType ? ' ' + planNames[planType] : ''}`;
}